import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const createPasswordGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.isAuthenticated().pipe(
    map((authenticated) => {
      const hasPassword =
        !!AuthService.currentFirebaseUser?.reloadUserInfo?.passwordUpdatedAt &&
        !!AuthService.currentFirebaseUser?.reloadUserInfo?.passwordHash;

      if (authenticated && !hasPassword) {
        router.navigate(['/create-password']);

        return false;
      }

      return true;
    }),
  );
};
